import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectOneUsersQueryItems } from '../../../../redux/one-users/selector';
import { useAppDispatch } from '../../../../hooks/hooks';
import { oneUsers } from '../../../../redux/one-users/action';
import PageLoader from '../../../../components/PageLoader';
import { OneUserComponent } from '../components/one-user.component';
import { tagNames } from '../../../../redux/tag-names/action';
import { selectTagNamesListItems } from '../../../../redux/tag-names/selector';


const PartnerOneUser= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const oneUserItems = useSelector(selectOneUsersQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
    const  tagNameListItems = useSelector(selectTagNamesListItems)
  const [ selectedOneUser, setSelectedOneUser ] = useState<any>([])
    const [
      selectedAddress,
      setSelectedAddress
    ] = useState<any>({
  
      PrimaryAddress: {},
      
  
    })
 
  const fetchOneUserById= ()=>{
    
    dispatch(oneUsers.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/query`,entity:'oneUsers',jsonData:{
    Records: [
      {   
              "Id": parmas?.id      
      }
    ]
  
  }})).then(()=>{
    setIsQuery(true)
  })

  }


  
 

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedOneUser({ ...selectedOneUser, [fields[0]]: value });
      setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  useEffect(
    () => {
      dispatch(oneUsers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users/list`,
        entity: 'oneUsers',
        jsonData: {}
    })).then(()=>{
      dispatch(tagNames.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
        entity: 'tagNames',
        jsonData: {}
    }))
    }).then(()=>{
      
      if (parmas?.id > 0) {
        fetchOneUserById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }    
    })
    
     
    },
    []
  )

  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedOneUser(oneUserItems?.result?.items)
      }
    },
    [isQuery]
  )
  
  

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(oneUsers.resetAction({ actionType: 'update' }))
      await dispatch(oneUsers.update({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
      entity:'oneUsers',
      jsonData:{
          
    Records: [
      {
         ...selectedOneUser

      }
      
    ]
 
    }})).then(()=>{
      back()
    })

    }else{
      await dispatch(oneUsers.resetAction({ actionType: 'create' }))
      await dispatch(oneUsers.create({
        url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity:'oneUsers',
        jsonData:{
          
      Records: [
        { 
            ...selectedOneUser
      }
      ]
    
    }})).then(()=>{
      back()
    })
    }
   
  }

  const back=()=>{
    navigate('/partner/contacts')
  } 
    return (
      <>
        {isLoading ? <PageLoader /> :
        <OneUserComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectedOneUser={selectedOneUser}
          back={back}
          handleFormSubmit={handleFormSubmit}
          id={parmas?.id}
          selectedAddress={selectedAddress}
          tagNames={tagNameListItems?.result?.items}
           
  
          
        />  
    }
      </>
    )
    
    }
   
    export default PartnerOneUser;